{
  "QUEUES": {
    "TITLE": "Colas de ejecución"
  }
}